import { render, staticRenderFns } from "./ShopOnline.vue?vue&type=template&id=24f0819d&scoped=true"
import script from "./ShopOnline.vue?vue&type=script&lang=js"
export * from "./ShopOnline.vue?vue&type=script&lang=js"
import style0 from "./ShopOnline.vue?vue&type=style&index=0&id=24f0819d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f0819d",
  null
  
)

export default component.exports